// extracted by mini-css-extract-plugin
export default {"blur-root":"styles_blur-root__S+heA","padding-top20":"styles_padding-top20__FVmKy","blur-modal":"styles_blur-modal__NlZdT","custom-backdrop":"styles_custom-backdrop__CerFv"};